import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Priority} from '../master-data/master-data.model';
import {MasterDataService} from '../master-data/master-data-service';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class PrioritiesResolve {
  private masterDataService = inject(MasterDataService);


  getPriorities(): Observable<Priority[]> {
    return this.masterDataService.getPriorities();
  }
}


export const prioritiesResolver: ResolveFn<Priority[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(PrioritiesResolve).getPriorities();
  };
